import React from "react";
import { Text, View } from "@react-pdf/renderer";

const AluPlateHeatExch2 = () => {
  return (
    <View
      style={{
        border: "2px solid black",
        fontSize: "8px",
        marginTop: "10px",
        paddingHorizontal: "5px",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <View
        style={{
          width: "2%",
          borderRight: "1px solid black",
        }}
      >
        <Text>1</Text>
      </View>
      <View
        style={{
          width: "96%",
          borderRight: "1px solid black",
          textAlign: "center",
        }}
      >
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            borderBottom: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <View style={{ borderRight: "1px solid black", width: "50%" }}>
            <Text style={{ fontSize: "10px", fontWeight: "600" }}>
              Aluplatten-Wärmetauscherteil
            </Text>
          </View>
          <View>
            <Text style={{ fontSize: "10px", fontWeight: "600", width: "50%" }}>
              Daten in Zuluft enthalten
            </Text>
          </View>
        </View>
        <View
          style={{
            textAlign: "left",
            // borderLeft: "1px solid black",
            paddingLeft: "2px",
          }}
        >
          <Text>Winter</Text>
          <Text>Sommer</Text>
        </View>
      </View>
      <View style={{ width: "2%", paddingLeft: "2px" }}>
        <Text></Text>
      </View>
    </View>
  );
};

export default AluPlateHeatExch2;
